import React, { useState } from "react";

import styles from "./Footer.module.scss";
import hipaaSealLogo from "assets/img/HIPPA-only.png";
import ScreenTutorialButton from "./components/ScreenTutorialButton/ScreenTutorialButton";
import FeedbackModal from "./components/FeedbackModal/FeedbackModal";

export default props => {

  const [showFeedbackModal, setFeedbackModal] = useState(false);

  return (
      <footer className={styles.footer}>
        <img
          className={styles["hipaa-seal-logo"]}
          src={hipaaSealLogo}
          alt="HIPAA Seal of Compliance Logo"
        />
        <div className={styles.copyright}>
          <span>The Guard - Version 4.1</span>
          <span>Copyright &#169; Compliancy Group, LLC. All Rights Reserved</span>
        </div>
        <ScreenTutorialButton onClick={() => { window.scrollTo(0,0);  setFeedbackModal(true) }} />
        {showFeedbackModal && <FeedbackModal setShowModal={setFeedbackModal} />}
        <div>
        
        </div>
      </footer>
    )
  }







